<template>
  <div class="products-index-base" :style="styles">
    <h1><img src="/static/img/recommend/lp/somarimone/products/newcorner_lp_head_somarimone.png" alt=""></h1>

    <block-about-slider :target-info="targetInfo" :color-scheme="counselorInfos.colorScheme" :lp-id="lpId"/>
    <block-three-years :target-info="targetInfo" :color-scheme="counselorInfos.colorScheme" :lp-id="lpId"/>
    <block-about-counselor :target-info="counselorInfos.information" :color-scheme="colorScheme" :lp-id="lpId"/>
    
    <lp-footer
      :color-scheme="footerColorScheme"
      :menu-list="footerMenuList"
      :scroll-pos="scrollPos"
      :lp-id="6"
    />
  </div>
</template>

<script>
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import LpFooter from '@/utvStore/components/recommend/lp/blocks/LpFooter'
import BlockAboutSlider from './partials/BlockAboutSlider'
import BlockThreeYears from './partials/BlockThreeYears'
import BlockAboutCounselor from '@/utvStore/components/recommend/lp/counselor/somarimone/blocks/BlockAboutCounselor'



import * as type from '@/utvStore/store/mutation-types'

export default {
  name: 'ProductsSomariIndex',
  components: {
    LpFooter,
    BlockAboutSlider,
    BlockThreeYears,
    BlockAboutCounselor,
  },
  props: {
    targetInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    colorScheme: {
      type: Object,
      default() {
        return {};
      },
    },
    lpId: {
      type: Number,
      default: 1,
    },
  },
  data(){
    return {
      scrollPos: -1,
    }
  },
  computed: {
    counselorInfos(){
      return BASIC_DATA.somarimone
    },
    footerColorScheme() {
      const sch = this.counselorInfos.colorScheme
      return {
        keyColor: sch.baseBg,
        fontColor: 'white',
        second: '#ffd69b',
      }
    },
    footerMenuList() {
      return [
        { label: `そまり百音TOP`, url: `/products/44`},
        ...DEFAULT_FOOTER_MENULIST,
      ]
    },
    styles(){
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
      }
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.counselorInfos.colorScheme)
  },
  mounted() {
    console.log('そまりさんカウンセラーデータ%O', this.counselorInfos)
    window.addEventListener('scroll', this.onScroll)
    this.onScroll()
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll(){
      this.scrollPos = window.scrollY
    },
  },
}</script>

<style scoped lang='scss'>
@import "../../../../../sass/commons/commonVariables.scss";



.products-index-base {
  width: 100%;
  background: url(/static/img/recommend/lp/touwa/products/bg_patterns_1.png) repeat-y center top;
  background-size: 100% auto;

  .block-about-counselor-base {
    @include mq('w580'){
      padding: 100px 0 60px;
    }
   
  }
}
h1 {
  margin: 0 0 20px;
}
.page-lead {
  width: 100%;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  margin: 0;
}
/deep/ {
  img {
    max-width: 100%;
    display: block;
  }
  p {
    margin: 0 auto 24px;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  

}
</style>




// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/somarimone/ProductsSomariIndex.vue